export default __webpack_public_path__ + "static/media/icon-favourite-add.316b398d.svg";